module.exports = __webpack_public_path__ + "static/media/Shailesh.a7eaf917.svg";